import { render, staticRenderFns } from "./MerchantsPage.vue?vue&type=template&id=685dabe3&"
import script from "./MerchantsPage.vue?vue&type=script&lang=js&"
export * from "./MerchantsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports